import React, { useState,useContext } from 'react';

const AppContext= React.createContext();

const AppProvider=({children})=>{
    const [isSwitch,setIsSwitch]=useState(true);

   
    const changeSwitch=(e)=>{
        console.log(isSwitch);
        setIsSwitch(e.target.checked);
    }

    return (
        <AppContext.Provider value={
            isSwitch,
            changeSwitch
        }>
            {children}
        </AppContext.Provider>
        )
};

export  const useGlobalContext=()=>{
    return useContext(AppContext);
}

export {AppProvider,AppContext}

